import { render } from "./NcrmMailjetWorkspace.vue?vue&type=template&id=168db492&scoped=true"
import script from "./NcrmMailjetWorkspace.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetWorkspace.vue?vue&type=script&lang=js"

import "./NcrmMailjetWorkspace.vue?vue&type=style&index=0&id=168db492&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168db492"]])

export default __exports__